<app-api-loader></app-api-loader>

<app-navbar ></app-navbar>

<div class="outlet-container">
    <router-outlet></router-outlet>
</div>

